export default __webpack_public_path__ + "static/media/Stones02.52aee097.png";